(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychomarketer-decision-map"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.pmInit === '1') return;
    root.dataset.pmInit = '1';
    if (!('IntersectionObserver' in window)) { root.classList.add('pm-v3-ready'); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('pm-v3-ready'); io.unobserve(e.target); }
      });
    }, {threshold:.12});
    io.observe(root);
  };
  document.querySelectorAll('[data-pm-v3]').forEach(init);
  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector?.('[data-pm-v3]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
